import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactSection from '../../components/feature/ContactSection';
import PageHeader from './components/PageHeader';
import ServicesGrid from './components/ServicesGrid';
import CTAStrip from './components/CTAStrip';

export default function Services() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PageHeader />
      <ServicesGrid />
      <CTAStrip />
      <ContactSection />
      <Footer />
    </div>
  );
}